export enum LanguageCode {
  HE_IL = 'he-IL',
  EN_US = 'en-US',
  DE_DE = 'de-DE',
  FR_FR = 'fr-FR',
  EN_AU = 'en-AU'
}

export enum ShortLanguageCode {
  HE = 'he',
  EN = 'en',
  DE = 'de',
  FR = 'fr'
}

export enum LanguageId {
  EN_US = 1,
  DE_DE = 11
}

export enum LanguageDirection {
  RTL = 'rtl',
  LTR = 'ltr'
}

export enum LanguageFontFamily {
  HE = 'Rubik, open_Sans, Arial, Sans_serif, serif, system-ui',
  EN = 'Montserrat, Helvetica, Arial, Sans_serif, serif'
}
